<template>
    <div class="news_item">
        <img :src="data.picUrl" alt="" class="img">
        <p>{{ data.title }}</p>
        <div class="info" >
            <van-icon :name="require('@/assets/imgs/icon71.png')" size="16" /> {{ data.browseCount }}
            <van-icon :name="require('@/assets/imgs/icon72.png')" size="16" /> {{ data.thumbsUpCount }}
        </div>
    </div>
</template>
<script setup>
import { richTextToPlainText } from '@/utils/util.js'
import { useRouter } from 'vue-router';
const router = useRouter()
defineProps({
    data: {
        type: Object,
        default: () => ({})
    }
})
</script>

<style scoped lang="scss">
.news_item {
    width: 100%; 
    position: relative;
    >img{
        width: 100%;
        height: 145rem;
        object-fit: cover;
    }
    p{
        margin: 10rem 0;
        font-size: 12rem;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .info{
        width: 110rem; height: 18rem; display: flex; background-color: rgba(255, 255, 255, 0.3); padding: 0 10rem; border-radius: 9rem;
        justify-content: space-between;
        align-items: center;
        font-size: 14rem;
        color: #fff;
        position: absolute;
        top: 8rem; right: 8rem;
    }
    
}
</style>